import { Component, inject } from '@angular/core';
import { CustomDialog } from '../modal-dialog/CustomDialog';
import { ModalResult } from '../../../core/interfaces/modal-result';
import { ResultState } from '../../../core/enums/result-state.enum';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'access-unavailable-dialog',
  templateUrl: './access-unavailable-dialog.component.html',
  styleUrl: './access-unavailable-dialog.component.scss',
})
export class AccessUnavailableDialogComponent extends CustomDialog {
  private readonly _authService = inject(AuthenticationService);
  public dialog = inject(DialogRef);

  public signOut(): void {
    this._authService.logout();
    this.closeDialog(ResultState.Cancelled);
  }

  public closeIcon(): void {
    const result: ModalResult = { data: 'change-customer', state: ResultState.Custom };
    this.close(result);
  }

  private closeDialog(state: ResultState): void {
    const result: ModalResult = { state };
    this.close(result);
  }
}
